import { useEffect, useRef, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import agent from '../../app/api/agent';
import './styles.css';

function AssetTracking() {
  const [assetDetails, setAssetDetails] = useState('');
  const [stop, setStop] = useState(false);

  let id1 = 'E2F2116060000208F9B9FD2B';
  let id2 = 'E2F2116060000208F9B9FD3B';
  let id3 = 'E2F2116060000208F9B9FD1B';

  // let id = id1;
  const id = useRef(id1);

  useEffect(() => {
    let interval = setInterval(async () => {
      try {
        if (assetDetails === 'user1') {
          id.current = id2;
        } else if (assetDetails === 'user2') {
          id.current = id3;
        }

        const res = await agent.Activities.movementtrackerWithCountReturn(
          id.current,
        );

        if (!res?.length) return;

        if (res === assetDetails) return;

        setAssetDetails(res);
        setStop(false);
      } catch {
        // setAssetDetails("");
      }
    }, 4000);

    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line
  }, [assetDetails]);

  useEffect(() => {
    let timer = setTimeout(() => {
      if (assetDetails) setStop(true);
    }, 60000);

    return () => clearTimeout(timer);
  }, [assetDetails]);

  return (
    <div className="asset-tracking-wrapper">
      {!stop && assetDetails ? (
        <>
          <div>
            <div style={{ position: 'relative' }}>
              <img
                src={
                  assetDetails === 'user1'
                    ? 'https://res.cloudinary.com/drvaemi9t/image/upload/v1671191555/xtj1yagapovfcks5vr5n.png'
                    : 'https://res.cloudinary.com/drvaemi9t/image/upload/v1671193936/duwfopvbfwe1jja3ui8c.png'
                }
                alt={'asset'}
                width={'200px'}
                height={'200px'}
              />
              <p
                style={{
                  position: 'absolute',
                  bottom: '20px',
                  padding: '10px 15px',
                  background:
                    'linear-gradient(1deg, rgb(0, 0, 0), transparent)',
                  width: '100%',
                  height: '40px',
                  color: 'white',
                  borderRadius: '0 0 24px 24px',
                  fontSize: '16px',
                  fontWeight: '700',
                }}
              >
                {assetDetails === 'user1' ? 'jagadeesh' : 'prasanth'}
              </p>
            </div>
            <div
              style={{
                padding: '20px',
                borderRadius: '20px',
                height: '100%',
                width: 'max-content',
                maxWidth: '600px',
              }}
            >
              {assetDetails === 'user1' || assetDetails === 'invalid asset' ? (
                <Icon name="cancel" color="red" size="massive" />
              ) : (
                <Icon name="check" color="green" size="massive" />
              )}
            </div>
          </div>
          {assetDetails === 'asset is valid' ? (
            <div>
              <img
                src={
                  'https://encrypted-tbn3.gstatic.com/images?q=tbn:ANd9GcSvB0iV-SZdwSGEmdiOt_sQujiv15wmVVEnj0uw9vl5aN90E577'
                }
                alt={'asset'}
                width={'200px'}
                height={'200px'}
              />
              <div
                style={{
                  padding: '20px',
                  borderRadius: '20px',
                  boxShadow: 'rgb(241, 241, 241) 0px 0px 0px 3px',
                  height: '100%',
                  width: 'max-content',
                  maxWidth: '600px',
                }}
              >
                <p
                  style={{
                    wordBreak: 'break-word',
                    display: 'grid',
                    gap: '14px',
                    fontSize: '16px',
                    color: '#676767',
                  }}
                >
                  <span>Jeene Ki Raah</span>
                  <span>The asset has been picked - out</span>
                </p>
              </div>
            </div>
          ) : (
            assetDetails === 'invalid asset' && (
              <h2>The user has no permission to take out this asset</h2>
            )
          )}
        </>
      ) : (
        <label style={{ textAlign: 'center' }}>
          <h2>No moment is tracking for now</h2>
          <img
            src={'/assets/wait.svg'}
            alt="wait"
            width={'400px'}
            height={'400px'}
          />
        </label>
      )}
    </div>
  );
}

export default AssetTracking;
